import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import React, { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
// @ts-ignore
import domtoimage from 'dom-to-image-more';
import { Context } from '../../store/content';
import { JpgIcon, PngIcon, SvgIcon, DownloadIcon } from '../icons';
import { BlockButton } from './';
import { Input } from './Input';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var icons = {
  jpg: /*#__PURE__*/_jsx(JpgIcon, {
    height: 26,
    style: {
      color: '#9c27b0'
    }
  }),
  png: /*#__PURE__*/_jsx(PngIcon, {
    height: 26,
    style: {
      color: '#009688'
    }
  }),
  svg: /*#__PURE__*/_jsx(SvgIcon, {
    height: 26,
    style: {
      color: '#ff5722'
    }
  })
};
var Warpper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0.5rem 0.5rem 0.5rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  gap: 0.8rem;\n"])));
var Toolbar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  cursor: pointer;\n  gap: 0.2rem;\n"])));
var ToolbarItem = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 0.1rem 0 0.1rem 0;\n  transition: all 0.3s;\n  svg {\n    display: block;\n  }\n  &:hover {\n    box-shadow: inset 0 0 0 1px rgb(0 0 0 / 19%);\n    border-radius: 0.2rem;\n  }\n  ", "\n"])), props => props.active && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      box-shadow: inset 0 0 0 1px rgb(0 0 0 / 19%);\n      border-radius: 0.2rem;\n    "]))));
var ButtonTitle = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose([""])));
var ScaleTool = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 0.3rem;\n"])));
var ScaleToolItem = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  background-color: rgb(0 0 0 / 13%);\n  padding: 0.1rem 0.2rem;\n  display: inline-block;\n  border-radius: 0.2rem;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: inline-block;\n  position: relative;\n  ", "\n"])), props => props.active && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      background-color: rgb(0 0 0 / 29%);\n      border-radius: 0.2rem;\n      &::after {\n        content: '  ';\n        display: block;\n        background-color: #333;\n        border-radius: 1px;\n        height: 2px;\n        bottom: -4px;\n        left: 0;\n        position: absolute;\n        width: 100%;\n      }\n    "]))));
export var DownloadView = () => {
  var {
    domImage,
    imageName,
    setImageName
  } = useContext(Context);
  var [type, setType] = useState('png');
  var [scale, setScale] = useState(2);
  var settingType = ev => {
    setType(ev.currentTarget.dataset.type);
  };
  var settingScale = ev => {
    setScale(Number(ev.currentTarget.dataset.type));
  };
  var handleDownload = () => {
    var fun = domtoimage.toPng;
    if (type === 'jpg') {
      fun = domtoimage.toJpeg;
    } else if (type === 'svg') {
      fun = domtoimage.toSvg;
    }
    var opts = {
      height: domImage.offsetHeight * scale,
      width: domImage.offsetWidth * scale,
      style: {
        transform: 'scale(' + scale + ')',
        transformOrigin: 'top left',
        height: domImage.offsetHeight * scale,
        width: domImage.offsetWidth * scale
      }
    };
    fun(domImage, opts).then(dataUrl => {
      var link = document.createElement('a');
      link.download = imageName + "." + type;
      link.href = dataUrl;
      link.click();
    });
  };
  return /*#__PURE__*/_jsxs(Warpper, {
    children: [/*#__PURE__*/_jsx(Input, {
      placeholder: "Please enter image name",
      value: imageName,
      onChange: ev => setImageName(ev.target.value)
    }), /*#__PURE__*/_jsxs(BlockButton, {
      onClick: handleDownload,
      children: [/*#__PURE__*/_jsx(DownloadIcon, {}), /*#__PURE__*/_jsx(ButtonTitle, {
        children: "Download"
      })]
    }), /*#__PURE__*/_jsxs(Toolbar, {
      children: [/*#__PURE__*/_jsx(ToolbarItem, {
        "data-type": "jpg",
        active: type === 'jpg',
        onClick: settingType,
        children: /*#__PURE__*/_jsx(JpgIcon, {
          height: 26,
          style: type === 'jpg' ? {
            color: '#9c27b0'
          } : {}
        })
      }), /*#__PURE__*/_jsx(ToolbarItem, {
        "data-type": "png",
        active: type === 'png',
        onClick: settingType,
        children: /*#__PURE__*/_jsx(PngIcon, {
          height: 26,
          style: type === 'png' ? {
            color: '#009688'
          } : {}
        })
      }), /*#__PURE__*/_jsx(ToolbarItem, {
        "data-type": "svg",
        active: type === 'svg',
        onClick: settingType,
        children: /*#__PURE__*/_jsx(SvgIcon, {
          height: 26,
          style: type === 'svg' ? {
            color: '#ff5722'
          } : {}
        })
      })]
    }), /*#__PURE__*/_jsxs(ScaleTool, {
      children: [/*#__PURE__*/_jsx(ScaleToolItem, {
        "data-type": "1",
        active: scale === 1,
        onClick: settingScale,
        children: "1x"
      }), /*#__PURE__*/_jsx(ScaleToolItem, {
        "data-type": "2",
        active: scale === 2,
        onClick: settingScale,
        children: "2x"
      }), /*#__PURE__*/_jsx(ScaleToolItem, {
        "data-type": "3",
        active: scale === 3,
        onClick: settingScale,
        children: "3x"
      }), /*#__PURE__*/_jsx(ScaleToolItem, {
        "data-type": "png",
        active: type === 'png',
        onClick: settingType,
        children: "png"
      }), /*#__PURE__*/_jsx(ScaleToolItem, {
        "data-type": "jpg",
        active: type === 'jpg',
        onClick: settingType,
        children: "jpg"
      }), /*#__PURE__*/_jsx(ScaleToolItem, {
        "data-type": "svg",
        active: type === 'svg',
        onClick: settingType,
        children: "svg"
      })]
    })]
  });
};